import React, { useState } from "react";
import { toast } from "sonner";
import { Lock, Mail, ShieldCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { adminApi, useAdmin } from "@/lib/admin";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAdmin();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@admin.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await adminApi.post("/login", { email, password });
      login(data.token, data.admin);
      nav("/admin");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-secondary text-secondary-foreground grid place-items-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <span className="w-10 h-10 rounded-lg bg-primary grid place-items-center">
            <ShieldCheck size={18} />
          </span>
          <div>
            <div className="font-heading font-bold text-lg">StitchQuote Admin</div>
            <div className="text-[10px] uppercase tracking-widest opacity-70">Platform console</div>
          </div>
        </div>
        <div className="bg-surface text-foreground rounded-xl p-6 border border-border">
          <h1 className="font-heading text-2xl font-bold mb-6">Sign in</h1>
          <Label className="sq-label">Email</Label>
          <div className="relative mt-1 mb-3">
            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input data-testid="admin-email" className="h-12 pl-9" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <Label className="sq-label">Password</Label>
          <div className="relative mt-1 mb-5">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input data-testid="admin-password" type="password" className="h-12 pl-9"
              value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button data-testid="admin-login-btn" onClick={submit} disabled={busy}
            className="h-12 w-full font-semibold">{busy ? "…" : "Sign in"}</Button>
        </div>
      </div>
    </div>
  );
}
